import s from '../GigAssMessage.module.sass'
import { Button } from '@shared/ui/Actions/Button'
import { Text } from '@shared/ui/Typography/Text'
import { FormEvent, useEffect, useState } from 'react'

/**
 * @function CanceledMessage - компонент сообщения о том, что запрос отменён
 * @param {Function} onRetry - функция, которая будет вызвана при нажатии на кнопку
 * @returns {JSX.Element}
 */
const CanceledMessage = ({ onRetry }: { onRetry: (e: FormEvent) => void }): JSX.Element => {
  const [isVisible, setIsVisible] = useState(false)

  const onRetryHandle = (e: FormEvent) => {
    setIsVisible(false)
    onRetry(e)
  }

  useEffect(() => {
    setIsVisible(true)
  }, [])

  return (
    <li className={`${s.message} ${s.messageStateConfused} ${isVisible ? s.visible : ''}`} data-type={'bot'}>
      <Text className={`${s.messageText} ${s.messageTextConfused}`} sizes='M' tag='p' children='Запрос отменён' />

      <Button type='button' onClick={onRetryHandle} className={s.retryButton} sizes='L' mode='ghost' disabled={false}>
        Попробовать ещё раз
      </Button>
    </li>
  )
}

export default CanceledMessage
